import { logEvent } from "firebase/analytics";
import type { EventParams } from "firebase/analytics";
import { getFirebaseAnalytics } from "../config/firebase";

type AnalyticsEventParams = EventParams | Record<string, unknown>;

const runWithAnalytics = async (callback: (analytics: NonNullable<Awaited<ReturnType<typeof getFirebaseAnalytics>>>) => void): Promise<void> => {
  const analytics = await getFirebaseAnalytics();

  if (!analytics) {
    return;
  }

  callback(analytics);
};

export const trackEvent = (eventName: string, eventParams?: AnalyticsEventParams): void => {
  runWithAnalytics((analytics) => {
    logEvent(analytics, eventName as any, eventParams);
  }).catch((error) => {
    console.error("Firebase Analytics event error:", error);
  });
};

export const trackPageView = (path: string, title: string = document.title): void => {
  const pagePath = path || "/";

  trackEvent("page_view", {
    page_title: title,
    page_location: window.location.href,
    page_path: pagePath,
  });
};
